import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Typography,
  Divider,
  TextField,
  List,
  ListItem,
  InputAdornment,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  SvgIcon,
  withWidth,
  Checkbox
} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import querystring from 'querystring';
import lodash from 'lodash';

import { Search, Check, AttachMoney } from '@material-ui/icons';
import {
  fetchAllSizes,
  fetchCategories,
  fetchBrands,
  fetchColors,
  fetchTags
} from '../../redux/actions/categories';
import { PRODUCTS_QUERY_RETRIEVED } from '../../redux/actions/types';
import { ReactComponent as CloseIcon } from '../../images/Icons/x-circle.svg';
import numberWithCommas from '../../utils/numberWithCommas';
import Alerts from './Alerts';
import { Autocomplete } from '@material-ui/lab';
import ColorSelector from '../../commons/ColorSelector';
import i18next from 'i18next';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    color: '#403f41',
    borderRadius: theme.shape.borderRadius,
    borderTopLeftRadius: 0,
    minHeight: '500px',
    width: '256px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 'unset',
      maxHeight: 'unset',
      minWidth: 'unset',
      overflow: 'auto',
      borderTopLeftRadius: theme.shape.borderRadius,
      position: 'relative'
    }
  },
  filter: {
    padding: theme.spacing(1),
    '& .MuiSlider-valueLabel': {
      '& > span': {
        '& > span': {
          fontWeight: 600,
          textShadow: '0px 3px 3px #000000'
        }
      }
    }
  },
  slider: {
    width: '80%'
  },
  filterOptions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.25)
    }
  },
  input: {
    fontSize: '0.9rem',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  textField: {
    borderRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    background: '#fff',
    '& > div': {
      '& > fieldset': {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  },
  list: {
    minHeight: '125px',
    height: '125px',
    overflow: 'auto',
    padding: 0,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderTop: 0,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    borderColor: 'rgba(0, 0, 0, 0.23)',
    backgroundColor: '#fff',
    '& > *': {
      justifyContent: 'center',
      cursor: 'pointer',
      fontWeight: 500
    }
  },
  filterOptionButton: {
    backgroundColor: '#fff',
    fontWeight: 400,
    fontSize: '0.8rem',
    padding: theme.spacing(1, 1),
    '& > span': {
      lineHeight: '1rem !important'
    }
  },
  inputLabel: {
    fontSize: '0.8rem'
  },
  filterOptionButtonCondition: {
    backgroundColor: '#fff',
    fontWeight: 400,
    width: '100px',
    padding: theme.spacing(1, 1),
    '& > span': {
      lineHeight: '1rem !important'
    }
  },
  appliedFilter: {
    '& > span': {
      position: 'relative',
      '& > svg': {
        position: 'absolute',
        width: '15px',
        height: '15px',
        top: '-12px',
        right: '-12px',
        '& > svg': {
          fill: 'white'
        }
      }
    }
  },
  selectedOption: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  },
  formControl: {
    width: '100%'
  },
  formGroupInline: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  filterHeader: {
    fontWeight: 500
  },
  closeIcon: {
    [theme.breakpoints.up('md')]: {
      display: 'hidden'
    },
    position: 'absolute',
    right: theme.spacing(0.5),
    top: theme.spacing(0.5),
    transform: `translate(-${theme.spacing(0.5)}px, -${theme.spacing(0.5)}px})`,
    cursor: 'pointer',
    color: '#707070',
    transition: 'all 1s ease-out',
    '&:hover': {
      color: '#000'
    }
  },
  radio: {
    padding: theme.spacing(0.5)
  },
  curvedSearch: {
    marginTop: theme.spacing(2),
    '& .MuiInputBase-root': {
      borderRadius: '25px',
      backgroundColor: '#fdfbfc'
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      fontSize: '1rem'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  colorSelector: {
    margin: theme.spacing(0.5)
  },
  tagsAutocomplete: {
    margin: theme.spacing(1, 0)
  }
});

const defaultFilters = {
  category: null,
  sub_category: null,
  sub_sub_category: [],
  brand: [],
  size: [],
  condition: [],
  role: [],
  promo: [],
  color: [],
  tags: [],
  subTypes: [],
  shipping: [],
  minPrice: null,
  maxPrice: null
};

const translateCondition = condition => {
  switch (condition) {
    case 'CONDITION_LIKE_NEW': {
      return 'Como nuevo';
    }
    case 'CONDITION_NEW_WITH_TAG': {
      return 'Nuevo con etiqueta';
    }
    case 'CONDITION_NEW_WITHOUT_TAG': {
      return 'Nuevo sin etiqueta';
    }
    case 'CONDITION_USED': {
      return 'Usado';
    }
    default:
      return '';
  }
};

const translateRole = role => {
  switch (role) {
    case 'ROLE_PREMIUM':
      return 'Premium';
    case 'ROLE_VIP':
      return 'VIP';
    case 'ROLE_CELEBRITY':
      return 'Celebrities';
    case 'ROLE_SHOWROOM':
      return 'Showroom';
    case 'ROLE_MARKETPLACE':
      return 'Marketplace';
    case 'ROLE_RESELLER':
      return 'Revendedora';
    case 'ROLE_SOLIDARY':
      return 'Solidaria';
    default:
      return role;
  }
};

const translatePromotion = promotion => {
  switch (promotion) {
    case 'TWO_FOR_ONE':
      return '2x1';
    case 'THREE_FOR_TWO':
      return '3x2';
    case 'TWENTY_PERCENT':
      return '20% Extra';
    case 'THIRTY_PERCENT':
      return '30% Extra';
    case 'FORTY_PERCENT':
      return '40% Extra';
    case 'FREE_SHIPPING':
      return 'Envio Gratis';
    default:
      return promotion;
  }
};

const translateShipping = shipping => {
  switch (shipping) {
    case 'ADDRESS':
      return 'A domicilio';
    case 'OCA':
      return 'Sucursales OCA';
    case 'CORREO ARGENTINO':
      return 'Sucursales Correo Argentino';
    case 'OFFICE':
      return 'Retiro sin cargo (CABA)';
    case 'CHILEXPRESS':
    case 'BLUEEXPRESS':
      return 'A sucursal';
    default:
      return shipping;
  }
};

const wrapArray = param => {
  if (!param) {
    return [];
  }
  if (Array.isArray(param)) {
    return param;
  }
  return [param];
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// We disabled tags filter for now.
// eslint-disable-next-line
const TagAutocomplete = ({
  options,
  values,
  setValue,
  label,
  type,

  classes
}) => (
  <Autocomplete
    multiple
    fullWidth
    className={classes.tagsAutocomplete}
    limitTags={2}
    options={options}
    noOptionsText="No encontramos tags con resultados"
    getOptionLabel={option =>
      option?.name || options.find(o => o.id === option)?.name
    }
    getOptionSelected={(option, value) => option.id === value}
    renderOption={(option, { selected }) => (
      <React.Fragment>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option?.name}
      </React.Fragment>
    )}
    value={values.filter(v => options.find(o => o.id === v && o.type === type))}
    onChange={(_, newValues) => setValue({ type, values: newValues })}
    renderInput={params => (
      <TextField
        {...params}
        variant="outlined"
        placeholder={`Tags de ${label}`}
      />
    )}
  />
);

class ProductFilter extends Component {
  constructor(props) {
    super(props);

    this.facetType = 'productFacets';

    const decodedQuery = querystring.decode(
      props.location.search.replace('?', '')
    );

    const wrappedQuery = {
      category: decodedQuery.category || null,
      sub_category:
        decodedQuery.category || !lodash.isEmpty(props.defaultFilter.category)
          ? decodedQuery.sub_category
          : null,
      sub_sub_category:
        (decodedQuery.category ||
          !lodash.isEmpty(props.defaultFilter.category)) &&
        (decodedQuery.sub_category ||
          !lodash.isEmpty(props.defaultFilter.sub_category))
          ? wrapArray(decodedQuery.sub_sub_category)
          : [],
      brand: wrapArray(decodedQuery.brand),
      size: wrapArray(decodedQuery.size),
      condition: wrapArray(decodedQuery.condition),
      role: wrapArray(decodedQuery.role),
      promo: wrapArray(decodedQuery.promo),
      shipping: wrapArray(decodedQuery.shipping),
      tags: wrapArray(decodedQuery.tags).map(t => Number(t)),
      color: wrapArray(decodedQuery.color).map(c => Number(c)),
      minPrice: decodedQuery.minPrice || null,
      maxPrice: decodedQuery.maxPrice || null,
      users: decodedQuery.users || null,
      user: wrapArray(decodedQuery.user).map(t => Number(t)),
      subTypes: wrapArray(decodedQuery.subTypes)
    };

    this.state = {
      facets: props[this.faceType] || {},
      appliedFilters: {
        user:
          (wrappedQuery.user.length > 0 && wrappedQuery.user) ||
          (!lodash.isEmpty(props.defaultFilter.user)
            ? props.defaultFilter.user
            : []),
        users: wrappedQuery.users,
        category:
          wrappedQuery.category ||
          (!lodash.isEmpty(props.defaultFilter.category)
            ? props.defaultFilter.category[0]
            : null),
        sub_category:
          wrappedQuery.sub_category ||
          (!lodash.isEmpty(props.defaultFilter.sub_category)
            ? props.defaultFilter.sub_category[0]
            : null),
        sub_sub_category:
          (wrappedQuery.sub_sub_category.length > 0 &&
            wrappedQuery.sub_sub_category) ||
          (!lodash.isEmpty(props.defaultFilter.sub_sub_category)
            ? props.defaultFilter.sub_sub_category
            : []),
        brand:
          (wrappedQuery.brand.length > 0 && wrappedQuery.brand) ||
          (!lodash.isEmpty(props.defaultFilter.brand)
            ? props.defaultFilter.brand
            : []),
        subTypes:
          (wrappedQuery.subTypes.length > 0 && wrappedQuery.subTypes) ||
          (!lodash.isEmpty(props.defaultFilter.subTypes)
            ? props.defaultFilter.subTypes
            : []),
        tags:
          (wrappedQuery.tags.length > 0 && wrappedQuery.tags) ||
          (!lodash.isEmpty(props.defaultFilter.tags)
            ? props.defaultFilter.tags
            : []),
        color:
          (wrappedQuery.color.length > 0 && wrappedQuery.color) ||
          (!lodash.isEmpty(props.defaultFilter.color)
            ? props.defaultFilter.color
            : []),
        size:
          (wrappedQuery.size.length > 0 && wrappedQuery.size) ||
          (!lodash.isEmpty(props.defaultFilter.size)
            ? props.defaultFilter.size
            : []),
        condition:
          (wrappedQuery.condition.length > 0 && wrappedQuery.condition) ||
          (!lodash.isEmpty(props.defaultFilter.condition)
            ? props.defaultFilter.condition
            : []),
        role:
          (wrappedQuery.role.length > 0 && wrappedQuery.role) ||
          (!lodash.isEmpty(props.defaultFilter.role)
            ? props.defaultFilter.role
            : []),
        promo:
          (wrappedQuery.promo.length > 0 && wrappedQuery.promo) ||
          (!lodash.isEmpty(props.defaultFilter.promo)
            ? props.defaultFilter.promo
            : []),
        shipping:
          (wrappedQuery.shipping.length > 0 && wrappedQuery.shipping) ||
          (!lodash.isEmpty(props.defaultFilter.shipping)
            ? props.defaultFilter.shipping
            : []),
        minPrice: wrappedQuery.minPrice || props.defaultFilter.minPrice || null,
        maxPrice: wrappedQuery.maxPrice || props.defaultFilter.maxPrice || null
      },

      priceRange: [
        props.defaultFilter.minPrice || 0,
        props.defaultFilter.maxPrice || 999999999
      ],

      lastPriceRange: [
        props.defaultFilter.minPrice || 0,
        props.defaultFilter.maxPrice || 999999999
      ],

      brandFilter: '',
      subSubCategoryFilter: '',
      dirty: false
    };
  }

  componentDidMount() {
    this.props.fetchBrands();
    this.props.fetchSizes();
    this.props.fetchCategories();
    this.props.fetchTags();
    this.props.fetchColors();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.clearFilterCount !== this.props.clearFilterCount &&
      this.state.dirty
    ) {
      this.setState({ appliedFilters: defaultFilters });
    }
    if (prevProps.productStatus !== this.props.productStatus) {
      if (this.props.productStatus === PRODUCTS_QUERY_RETRIEVED) {
        this.handleUpdateFacets(this.state.dirty);
        if (!this.state.dirty) {
          this.handleUrlFilter();
        }
      }
    }

    if (
      prevState.appliedFilters.minPrice !== this.state.appliedFilters.minPrice
    ) {
      this.setState(state => ({
        ...state,
        lastPriceRange: [state.appliedFilters.minPrice, state.lastPriceRange[1]]
      }));
    }

    if (
      prevState.appliedFilters.maxPrice !== this.state.appliedFilters.maxPrice
    ) {
      this.setState(state => ({
        ...state,
        lastPriceRange: [state.lastPriceRange[0], state.appliedFilters.maxPrice]
      }));
    }

    // On url change only related to /{stuff}/{moreStuff}, not related to ?query=&field=stuff
    // So, handleURL is not needed, as defaultFilter is only affected by aforementioned URLs
    if (!lodash.isEqual(prevProps.defaultFilter, this.props.defaultFilter)) {
      this.setState({
        dirty: false,
        appliedFilters: {
          users: this.props.defaultFilter.users || null,
          user: !lodash.isEmpty(this.props.defaultFilter.user)
            ? this.props.defaultFilter.user
            : [],
          category: !lodash.isEmpty(this.props.defaultFilter.category)
            ? this.props.defaultFilter.category[0]
            : null,
          sub_category: !lodash.isEmpty(this.props.defaultFilter.sub_category)
            ? this.props.defaultFilter.sub_category[0]
            : null,
          sub_sub_category: !lodash.isEmpty(
            this.props.defaultFilter.sub_sub_category
          )
            ? this.props.defaultFilter.sub_sub_category
            : [],
          brand: !lodash.isEmpty(this.props.defaultFilter.brand)
            ? this.props.defaultFilter.brand
            : [],
          color: !lodash.isEmpty(this.props.defaultFilter.color)
            ? this.props.defaultFilter.color
            : [],
          tags: !lodash.isEmpty(this.props.defaultFilter.tags)
            ? this.props.defaultFilter.tags
            : [],
          size: !lodash.isEmpty(this.props.defaultFilter.size)
            ? this.props.defaultFilter.size
            : [],
          condition: !lodash.isEmpty(this.props.defaultFilter.condition)
            ? this.props.defaultFilter.condition
            : [],
          role: !lodash.isEmpty(this.props.defaultFilter.role)
            ? this.props.defaultFilter.role
            : [],
          subTypes: !lodash.isEmpty(this.props.defaultFilter.subTypes)
            ? this.props.defaultFilter.subTypes
            : [],
          promo: !lodash.isEmpty(this.props.defaultFilter.promo)
            ? this.props.defaultFilter.promo
            : [],
          shipping: !lodash.isEmpty(this.props.defaultFilter.shipping)
            ? this.props.defaultFilter.shipping
            : [],
          minPrice: this.props.defaultFilter.minPrice || null,
          maxPrice: this.props.defaultFilter.maxPrice || null
        }
      });
    }
  }

  // This is used to apply the filters in the URL to the variables pertaining this component.
  // This function uses state.appliedFilter, that has null or array properties,
  // Then wraps url query's properties with arrays to standardize data types,
  // then proceeds to merge applied filters with query filters in case user selected another
  // item from that type, as you would want both. Ex: /marca/adidas?query=&brand=47Street
  // would leave [ adidas, 47street ]. Set is to merge without duplicates, filter(Boolean)
  // is because it generated "" in the array, so it eliminates that one.
  // Remember that category and subCategory isn't an array, so you need to choose only one of the values,
  // on the other hand, for brands, subsubcats and stuff, you probably would like to have both the
  // values from match properties and the search properties.
  handleUrlFilter = () => {
    const decodedQuery = querystring.decode(
      this.props.location.search.replace('?', '')
    );

    const wrappedQuery = {
      category: decodedQuery.category || null,
      sub_category: decodedQuery.category ? decodedQuery.sub_category : null,
      sub_sub_category:
        decodedQuery.category && decodedQuery.sub_category
          ? wrapArray(decodedQuery.sub_sub_category)
          : [],
      brand: wrapArray(decodedQuery.brand),
      size: wrapArray(decodedQuery.size),
      condition: wrapArray(decodedQuery.condition),
      role: wrapArray(decodedQuery.role),
      promo: wrapArray(decodedQuery.promo),
      shipping: wrapArray(decodedQuery.shipping),
      color: wrapArray(decodedQuery.color).map(c => Number(c)),
      tags: wrapArray(decodedQuery.tags).map(t => Number(t)),
      minPrice: decodedQuery.minPrice || null,
      maxPrice: decodedQuery.maxPrice || null,
      users: decodedQuery.users || null,
      user: wrapArray(decodedQuery.user).map(u => Number(u)),
      subTypes: wrapArray(decodedQuery.subTypes)
    };

    this.setState(
      state => ({
        ...state,
        dirty: true,
        priceRange: [
          wrappedQuery.minPrice || state.priceRange[0],
          wrappedQuery.maxPrice || state.priceRange[1]
        ],
        appliedFilters: {
          users: wrappedQuery.users || state.appliedFilters.users || null,
          user: [
            ...new Set([...state.appliedFilters.user, ...wrappedQuery.user])
          ].filter(Boolean),
          category:
            wrappedQuery.category || state.appliedFilters.category || null,
          sub_category:
            wrappedQuery.sub_category ||
            state.appliedFilters.sub_category ||
            null,
          sub_sub_category: [
            ...new Set([
              ...state.appliedFilters.sub_sub_category,
              ...wrappedQuery.sub_sub_category
            ])
          ].filter(Boolean),
          brand: [
            ...new Set([...state.appliedFilters.brand, ...wrappedQuery.brand])
          ].filter(Boolean),
          subTypes: [
            ...new Set([
              ...state.appliedFilters.subTypes,
              ...wrappedQuery.subTypes
            ])
          ].filter(Boolean),
          color: [
            ...new Set([...state.appliedFilters.color, ...wrappedQuery.color])
          ].filter(Boolean),
          tags: [
            ...new Set([...state.appliedFilters.tags, ...wrappedQuery.tags])
          ].filter(Boolean),
          size: [
            ...new Set([...state.appliedFilters.size, ...wrappedQuery.size])
          ].filter(Boolean),
          condition: [
            ...new Set([
              ...state.appliedFilters.condition,
              ...wrappedQuery.condition
            ])
          ].filter(Boolean),
          role: [
            ...new Set([...state.appliedFilters.role, ...wrappedQuery.role])
          ].filter(Boolean),
          promo: [
            ...new Set([...state.appliedFilters.promo, ...wrappedQuery.promo])
          ].filter(Boolean),
          shipping: [
            ...new Set([
              ...state.appliedFilters.shipping,
              ...wrappedQuery.shipping
            ])
          ].filter(Boolean),
          minPrice:
            wrappedQuery.minPrice || state.appliedFilters.minPrice || null,
          maxPrice:
            wrappedQuery.maxPrice || state.appliedFilters.maxPrice || null
        }
        //  This callback is here to make sure that if URL comes with a query (?query=&field...)
        //  product component makes an API call with correspondent filter.
      }),
      () => {
        if (
          !lodash.isEmpty(
            querystring.decode(this.props.location.search.replace('?', ''))
          )
        ) {
          this.createArrayToEncodeForURL();
        }
      }
    );
  };

  handleUpdateFacets = dirty => {
    this.setState(state => {
      const newFacets = Object.keys(this.props[this.facetType]).reduce(
        (nf, f) => {
          if (
            // This check is in order to update facets for other appliedFilters
            // to prevent being able to remove filters in a way
            // that would make the request not make sense
            (f !== state.lastFilter && dirty) ||
            !dirty ||
            (Array.isArray(state.appliedFilters[f]) &&
              state.appliedFilters[f].length === 0) ||
            state.appliedFilters[f] === null
          ) {
            nf[f] = this.props[this.facetType][f];
          } else {
            if (this.props[this.facetType][f] && state.facets[f]) {
              // eslint-disable-next-line no-param-reassign
              nf[f] = { ...this.props[this.facetType][f], ...state.facets[f] };
            } else {
              // eslint-disable-next-line no-param-reassign
              nf[f] = state.facets[f];
            }
          }
          return nf;
        },
        {}
      );

      const isPromosPage = this.props.location.pathname.includes(
        '/productos/filtro/en-promo-hoy'
      );

      // In case there's no active promos, we won't show anything but we'll clean
      // the appliedFilter to make sure if the user change categories it will
      // not try to keep requesting for promos in this case.
      if (
        !dirty &&
        isPromosPage &&
        this.props[this.facetType].promo.length === 0 &&
        state.appliedFilters.promo.length !== 0
      ) {
        return {
          ...state,
          facets: newFacets,
          appliedFilters: {
            ...state.appliedFilters,
            promo: []
          }
        };
      }

      return {
        ...state,
        facets: newFacets,
        appliedFilters: {
          ...state.appliedFilters,
          minPrice:
            !dirty && newFacets.price && newFacets.price.min
              ? null
              : state.appliedFilters.minPrice,
          maxPrice:
            !dirty && newFacets.price && newFacets.price.max
              ? null
              : state.appliedFilters.maxPrice
        },
        priceRange: [
          newFacets.price &&
          newFacets.price.min &&
          (state.appliedFilters.minPrice === undefined || !dirty)
            ? newFacets.price.min
            : state.priceRange[0],
          newFacets.price &&
          newFacets.price.max &&
          (state.appliedFilters.maxPrice === undefined || !dirty)
            ? newFacets.price.max
            : state.priceRange[1]
        ]
      };
    });
  };

  handlePriceChange = (min, newPrice) => {
    this.setState(state => ({
      ...state,
      priceRange: min
        ? [newPrice, state.priceRange[1]]
        : [state.priceRange[0], newPrice]
    }));
  };

  handleChange = (field, newValue) => {
    this.setState(
      state => {
        if (field === 'users') {
          return {
            ...state,
            lastFilter: field,
            appliedFilters: {
              ...state.appliedFilters,
              users: newValue ? null : 'followings'
            }
          };
        }
        if (field === 'tags') {
          let selectedTags = state.appliedFilters.tags;
          let { type, values, onlyOne } = newValue;
          if (onlyOne) {
            return {
              ...state,
              lastFilter: field,
              appliedFilters: {
                ...state.appliedFilters,
                tags: selectedTags.filter(t => t !== values)
              }
            };
          }
          let previousTags = selectedTags.map(t =>
            this.props.tags.find(tag => tag.id === t)
          );
          let filteredTags = previousTags
            .filter(t => t.type !== type)
            .map(t => t.id);
          let newTags = values.map(v => v?.id || v);
          return {
            ...state,
            lastFilter: field,
            appliedFilters: {
              ...state.appliedFilters,
              tags: [...filteredTags, ...newTags]
            }
          };
        }
        if (Array.isArray(state.appliedFilters[field])) {
          if (state.appliedFilters[field].includes(newValue)) {
            return {
              ...state,
              subSubCategoryFilter:
                field === 'sub_sub_category' ? '' : state.subSubCategoryFilter,
              brandFilter: field === 'brand' ? '' : state.brandFilter,
              lastFilter: field,
              appliedFilters: {
                ...state.appliedFilters,
                [field]:
                  field === 'promo'
                    ? state.appliedFilters.promo
                        .filter(p => {
                          if (!state.facets.promo) {
                            return false;
                          }
                          if (Object.keys(state.facets.promo).includes(p)) {
                            return true;
                          }
                          return false;
                        })
                        .filter(v => v !== newValue)
                    : state.appliedFilters[field].filter(v => v !== newValue)
              }
            };
          }
          return {
            ...state,
            lastFilter: field,
            subSubCategoryFilter:
              field === 'sub_sub_category' ? '' : state.subSubCategoryFilter,
            brandFilter: field === 'brand' ? '' : state.brandFilter,
            appliedFilters: {
              ...state.appliedFilters,
              [field]: [...state.appliedFilters[field], newValue]
            }
          };
        }

        // If we are currently on a filter's page like the brand one or the promos
        // when we clean the filters when changing categories we won't clean them.
        const isBrandsPage = this.props.location.pathname.includes(
          '/productos/marca/'
        );
        const isPromosPage = this.props.location.pathname.includes(
          '/productos/filtro/en-promo-hoy'
        );

        return {
          ...state,
          lastFilter: field,
          appliedFilters: {
            ...state.appliedFilters,
            sub_category:
              field === 'category' ? null : state.appliedFilters.sub_category,
            sub_sub_category:
              field === 'sub_category' || field === 'category'
                ? []
                : state.appliedFilters.sub_sub_category,
            brand:
              (field === 'category' || field === 'sub_category') &&
              !isBrandsPage
                ? []
                : state.appliedFilters.brand,
            color:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.color,
            tags:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.tags,
            size:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.size,
            condition:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.condition,
            role:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.role,
            subTypes:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.subTypes,
            promo:
              (field === 'category' || field === 'sub_category') &&
              !isPromosPage
                ? []
                : state.appliedFilters.promo,
            shipping:
              field === 'category' || field === 'sub_category'
                ? []
                : state.appliedFilters.shipping,
            [field]: newValue
          }
        };
      },
      () => {
        if (
          this.props.location.pathname.includes !== '/productos' &&
          this.props.location.pathname.includes !== '/productos/favoritos' &&
          !this.props.location.pathname.includes('vestidor') &&
          this.props.location.pathname !== '/productos' &&
          this.props.location.pathname !== '/productos/favoritos'
        ) {
          this.props.history.replace({ pathname: '/productos' });
        }
        this.createArrayToEncodeForURL();
      }
    );
  };

  createArrayToEncodeForURL = () => {
    const filterObject = {
      users: this.state.appliedFilters.users,
      user: this.state.appliedFilters.user || undefined,
      category: this.state.appliedFilters.category
        ? [this.state.appliedFilters.category]
        : undefined,
      sub_category: this.state.appliedFilters.sub_category
        ? [this.state.appliedFilters.sub_category]
        : undefined,
      sub_sub_category: this.state.appliedFilters.sub_sub_category || undefined,
      brand: this.state.appliedFilters.brand || undefined,
      color: this.state.appliedFilters.color || undefined,
      tags: this.state.appliedFilters.tags || undefined,
      size: this.state.appliedFilters.size || undefined,
      condition: this.state.appliedFilters.condition || undefined,
      role: this.state.appliedFilters.role || undefined,
      subTypes: this.state.appliedFilters.subTypes || undefined,
      promo: this.state.appliedFilters.promo || undefined,
      shipping: this.state.appliedFilters.shipping || undefined,
      minPrice: this.state.appliedFilters.minPrice || undefined,
      maxPrice: this.state.appliedFilters.maxPrice || undefined
    };

    const filtersToEncode = Object.keys(filterObject).reduce(
      (filter, param) => {
        if (
          (Array.isArray(filterObject[param]) &&
            filterObject[param].length > 0) ||
          (!Array.isArray(filterObject[param]) &&
            filterObject[param] !== undefined)
        ) {
          // eslint-disable-next-line
          filter[param] = filterObject[param];
        }
        return filter;
      },
      {}
    );
    // TODO(Toti):
    // When we switch Category or SubCategory we want to change the
    // URL of /productos/<category>/<subCategory> to the new ones
    // For Subsubcategory, if only one is selected we should change the third
    // parameter /subSubCategory and if there's more than one we should
    // only show up to /subCategory and the rest of the subSubs would go
    // in the queryParams of the URL for parsing.
    if (this.props.onFilterChange) {
      if (
        this.props.location.pathname !== '/productos' &&
        !this.props.location.pathname.includes('/vestidor')
      ) {
        this.props.history.replace({ pathname: '/productos' });
      }
      this.props.onFilterChange(filtersToEncode);
    }
  };

  render() {
    const { classes, categories } = this.props;

    // Ideas for brand facet handling:
    // 1) Always show all brands: this will always display the one that is selected, if there were.
    // 2) Show an array that includes the one I selected from url and other #pageSize of facets.
    // For this, ask for facets first with getProducts(), then remake API call including the query,
    // Then load the facets here, and finally
    // [props.brands.find(brand => brand.id===selected), find(facet => facet.id!===selected)]
    // Adapting this code in case selected brands are several (could happen).
    // The last part is so brand display isn't repeated.
    // DISADVANTAGE: if I facet this way and just keep these old facets,
    // It is increasingly difficult if I query by something like
    // /productos/kids/ropa/jeans?query=&brand=${adidasID}&brand=${nikeID} and so forth.
    // This is because you will need to keep on checking the new facets for some arrays to display,
    // but the old facets for brands? I'm really burnt out right now, but I heavily suspect it is a bolonki.
    // Thus, I'm leaving the whole brands array. I'm leaving the previous solution commmented in case it is useful
    const brands = this.props.brands.filter(
      brand =>
        this.state.facets.brand &&
        Object.keys(this.state.facets.brand).includes(brand.id)
    );
    const tags = this.props.tags.filter(
      tag =>
        this.state.facets.tags &&
        Object.keys(this.state.facets.tags).includes(`${tag.id}`)
    );
    const colors = this.props.colors.filter(
      color =>
        this.state.facets.color &&
        Object.keys(this.state.facets.color).includes(`${color.id}`)
    );
    const sizes = this.props.sizes.filter(
      size =>
        this.state.facets.size &&
        Object.keys(this.state.facets.size).includes(size.id)
    );
    let subCategories =
      this.state.appliedFilters.category && this.props.categories.length > 0
        ? this.props.categories.find(
            c => c.id === this.state.appliedFilters.category
          )?.sub_categories
        : [];
    subCategories = subCategories
      ? subCategories.filter(c => !c.disabled_shop)
      : subCategories;
    let subSubCategories =
      this.state.appliedFilters.category &&
      this.state.appliedFilters.sub_category &&
      this.props.categories.length > 0
        ? this.props.categories
            .find(c => c.id === this.state.appliedFilters.category)
            ?.sub_categories?.find(
              c => c.id === this.state.appliedFilters.sub_category
            )?.sub_sub_categories || []
        : [];
    subSubCategories = subSubCategories.filter(
      cat =>
        ((this.state.facets.sub_sub_category &&
          Object.keys(this.state.facets.sub_sub_category).includes(cat.id)) ||
          this.state.appliedFilters.sub_sub_category.includes(cat.id)) &&
        !cat.disabled_shop
    );

    return (
      <div className={classes.root}>
        {!this.props.dresserView && (
          <Alerts
            appliedFilters={this.state.appliedFilters}
            visible={Object.keys(this.state.facets).length !== 0}
          />
        )}
        {!this.props.visible && ''}
        {Object.keys(this.state.facets).length === 0 && this.props.visible && (
          <>
            <SvgIcon className={classes.closeIcon} onClick={this.props.onClose}>
              <CloseIcon />
            </SvgIcon>
            No hay filtros disponibles
          </>
        )}
        {Object.keys(this.state.facets).length > 0 && this.props.visible && (
          <>
            <SvgIcon className={classes.closeIcon} onClick={this.props.onClose}>
              <CloseIcon />
            </SvgIcon>
            <>
              <div className={classes.filter} style={{ paddingBottom: 0 }}>
                {/* Applied filters section */}
                <div className={classes.filterOptions}>
                  {this.props.queryString !== '' && (
                    <Button
                      className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                      onClick={this.props.removeQueryString}
                      variant="outlined"
                    >
                      <SvgIcon color="primary">
                        <CloseIcon />
                      </SvgIcon>
                      Búsqueda: {this.props.queryString}
                    </Button>
                  )}
                  {/* Price filters applied */}
                  {this.state.appliedFilters.minPrice &&
                    this.state.facets.price &&
                    this.state.facets.price.min !==
                      Number(this.state.appliedFilters.minPrice) && (
                      <Button
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() => this.handleChange('minPrice', undefined)}
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        Precio mínimo $
                        {numberWithCommas(this.state.appliedFilters.minPrice)}
                      </Button>
                    )}
                  {this.state.appliedFilters.maxPrice &&
                    this.state.facets.price &&
                    this.state.facets.price.max !==
                      Number(this.state.appliedFilters.maxPrice) && (
                      <Button
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() => this.handleChange('maxPrice', undefined)}
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        Precio máximo $
                        {numberWithCommas(this.state.appliedFilters.maxPrice)}
                      </Button>
                    )}
                  {/* Brands applied filters */}
                  {brands
                    .filter(brand =>
                      this.state.appliedFilters.brand.includes(brand.id)
                    )
                    .map(brand => (
                      <Button
                        key={brand.id}
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() => this.handleChange('brand', brand.id)}
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        {brand.name}
                      </Button>
                    ))}
                  {/* Tags applied filters */}
                  {tags
                    .filter(tag =>
                      this.state.appliedFilters.tags.includes(tag.id)
                    )
                    .map(tag => (
                      <Button
                        key={tag.id}
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() =>
                          this.handleChange('tags', {
                            values: tag.id,
                            onlyOne: true
                          })
                        }
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        {tag.name}
                      </Button>
                    ))}
                  {/* Colors applied filters */}
                  {colors
                    .filter(color =>
                      this.state.appliedFilters.color.includes(color.id)
                    )
                    .map(color => (
                      <Button
                        key={color.id}
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() => this.handleChange('color', color.id)}
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        {color.name}
                      </Button>
                    ))}
                  {/* SubSubCategories applied filters */}
                  {subSubCategories
                    .filter(cat =>
                      this.state.appliedFilters.sub_sub_category.includes(
                        cat.id
                      )
                    )
                    .map(cat => (
                      <Button
                        key={cat.id}
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() =>
                          this.handleChange('sub_sub_category', cat.id)
                        }
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        {cat.name}
                      </Button>
                    ))}
                  {/* Sizes applied filters */}
                  {sizes
                    .filter(size =>
                      this.state.appliedFilters.size.includes(size.id)
                    )
                    .map(size => (
                      <Button
                        key={size.id}
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        onClick={() => this.handleChange('size', size.id)}
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        {size.name}
                      </Button>
                    ))}
                  {/* Condition applied filters */}
                  {this.state.facets.condition &&
                    Object.keys(this.state.facets.condition)
                      .filter(condition =>
                        this.state.appliedFilters.condition.includes(condition)
                      )
                      .map(condition => (
                        <Button
                          key={condition}
                          className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                          onClick={() =>
                            this.handleChange('condition', condition)
                          }
                          variant="outlined"
                        >
                          <SvgIcon color="primary">
                            <CloseIcon />
                          </SvgIcon>
                          {translateCondition(condition)}
                        </Button>
                      ))}
                  {/* Roles applied filters */}
                  {this.state.facets.role &&
                    Object.keys(this.state.facets.role)
                      .filter(role =>
                        this.state.appliedFilters.role.includes(role)
                      )
                      .map(role => (
                        <Button
                          key={role}
                          className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                          onClick={() => this.handleChange('role', role)}
                          variant="outlined"
                        >
                          <SvgIcon color="primary">
                            <CloseIcon />
                          </SvgIcon>
                          {translateRole(role)}
                        </Button>
                      ))}
                  {/** Applied filters for subTypes */}
                  {this.state.facets.subTypes &&
                    Object.keys(this.state.facets.subTypes)
                      .filter(subType =>
                        this.state.appliedFilters.subTypes.includes(subType)
                      )
                      .map(subType => (
                        <Button
                          key={subType}
                          className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                          onClick={() => this.handleChange('subTypes', subType)}
                          variant="outlined"
                        >
                          <SvgIcon color="primary">
                            <CloseIcon />
                          </SvgIcon>
                          {translateRole(subType)}
                        </Button>
                      ))}
                  {!this.props.dresserView &&
                    this.state.appliedFilters.users === 'followings' && (
                      <Button
                        onClick={() =>
                          this.handleChange(
                            'users',
                            this.state.appliedFilters.users === 'followings'
                          )
                        }
                        className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                        variant="outlined"
                      >
                        <SvgIcon color="primary">
                          <CloseIcon />
                        </SvgIcon>
                        {i18next.t('dressersYouFollow', { ns: 'shop' })}
                      </Button>
                    )}
                  {/* Promo applied filters */}
                  {this.state.facets.promo &&
                    Object.keys(this.state.facets.promo)
                      .filter(promo =>
                        this.state.appliedFilters.promo.includes(promo)
                      )
                      .map(promo => (
                        <Button
                          key={promo}
                          className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                          onClick={() => this.handleChange('promo', promo)}
                          variant="outlined"
                        >
                          <SvgIcon color="primary">
                            <CloseIcon />
                          </SvgIcon>
                          {translatePromotion(promo)}
                        </Button>
                      ))}
                  {/* Shipping applied filters */}
                  {this.state.facets.shipping &&
                    Object.keys(this.state.facets.shipping)
                      .filter(shipping =>
                        this.state.appliedFilters.shipping.includes(shipping)
                      )
                      .map(shipping => (
                        <Button
                          key={shipping}
                          className={`${classes.filterOptionButton} ${classes.selectedOption} ${classes.appliedFilter}`}
                          onClick={() =>
                            this.handleChange('shipping', shipping)
                          }
                          variant="outlined"
                        >
                          <SvgIcon color="primary">
                            <CloseIcon />
                          </SvgIcon>
                          {translateShipping(shipping)}
                        </Button>
                      ))}
                </div>
              </div>
              <div className={classes.filter} style={{ paddingBottom: 0 }}>
                <div className={classes.filterOptions}>
                  <FormControl classes={{ root: classes.formControl }}>
                    <FormLabel
                      component="legend"
                      className={classes.filterHeader}
                    >
                      Tipo:
                    </FormLabel>
                    <RadioGroup
                      classes={{ root: classes.formGroupInline }}
                      aria-label="tipo categoria"
                      value={this.state.appliedFilters.category}
                      onChange={({ target: { value } }) =>
                        this.handleChange('category', value)
                      }
                    >
                      {categories.length > 1 && (
                        <FormControlLabel
                          control={
                            <Radio
                              checked={!this.state.appliedFilters.category}
                              color="primary"
                              className={classes.radio}
                            />
                          }
                          label="Todas"
                          classes={{
                            label: classes.inputLabel
                          }}
                        />
                      )}
                      {categories.map(category => (
                        <FormControlLabel
                          key={category.id}
                          control={
                            <Radio className={classes.radio} color="primary" />
                          }
                          value={category.id}
                          label={category.name}
                          classes={{
                            label: classes.inputLabel
                          }}
                        >
                          {category.name}
                        </FormControlLabel>
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </>
            {this.state.appliedFilters.category && (
              <>
                <div className={classes.filter} style={{ paddingTop: 0 }}>
                  <div className={classes.filterOptions}>
                    <FormControl
                      classes={{ root: classes.formControl }}
                      style={{ alignItems: 'center' }}
                    >
                      <RadioGroup
                        aria-label="tipo categoria"
                        value={this.state.appliedFilters.sub_category}
                        onChange={({ target: { value } }) =>
                          this.handleChange('sub_category', value)
                        }
                      >
                        {subCategories.length > 1 && (
                          <FormControlLabel
                            control={
                              <Radio
                                checked={
                                  !this.state.appliedFilters.sub_category
                                }
                                color="primary"
                                className={classes.radio}
                              />
                            }
                            label="Todas"
                            classes={{
                              label: classes.inputLabel
                            }}
                          />
                        )}
                        {subCategories.map(category => (
                          <FormControlLabel
                            key={category.id}
                            control={
                              <Radio
                                className={classes.radio}
                                color="primary"
                              />
                            }
                            value={category.id}
                            label={category.name}
                            classes={{
                              label: classes.inputLabel
                            }}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <Divider />
              </>
            )}
            {this.state.appliedFilters.sub_category &&
              subSubCategories.length > 0 && (
                <>
                  <div className={classes.filter}>
                    <Typography className={classes.filterHeader}>
                      Categoría:
                    </Typography>
                    <div className={classes.filterSearch}>
                      <TextField
                        fullWidth
                        classes={{
                          root: classes.textField
                        }}
                        InputProps={{
                          classes: {
                            input: classes.input
                          },
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          )
                        }}
                        variant="outlined"
                        type="text"
                        placeholder="Buscar categorías"
                        value={this.state.subSubCategoryFilter}
                        onChange={({ target: { value } }) =>
                          this.setState({ subSubCategoryFilter: value })
                        }
                      />
                      <List className={classes.list}>
                        {subSubCategories
                          .filter(
                            this.state.subSubCategoryFilter === ''
                              ? () => true
                              : category =>
                                  category.name
                                    .toUpperCase()
                                    .includes(
                                      this.state.subSubCategoryFilter
                                        .trim()
                                        .toUpperCase()
                                    )
                          )
                          .map(category => (
                            <ListItem
                              onClick={() =>
                                this.handleChange(
                                  'sub_sub_category',
                                  category.id
                                )
                              }
                              key={category.id}
                              className={
                                this.state.appliedFilters.sub_sub_category.includes(
                                  category.id
                                )
                                  ? classes.selectedItem
                                  : ''
                              }
                              divider
                            >
                              {this.state.appliedFilters.sub_sub_category.includes(
                                category.id
                              ) && (
                                <Check
                                  color="primary"
                                  style={{ marginRight: '6px' }}
                                />
                              )}
                              {category.name}
                            </ListItem>
                          ))}
                      </List>
                    </div>
                  </div>
                  <Divider />
                </>
              )}
            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>Marcas:</Typography>
              <div className={classes.filterSearch}>
                <TextField
                  fullWidth
                  classes={{
                    root: classes.textField
                  }}
                  InputProps={{
                    classes: {
                      input: classes.input
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    )
                  }}
                  variant="outlined"
                  type="text"
                  placeholder="Buscar marca"
                  value={this.state.brandFilter}
                  onChange={({ target: { value } }) =>
                    this.setState({ brandFilter: value })
                  }
                />
                <List className={classes.list}>
                  {brands
                    .filter(
                      this.state.brandFilter === ''
                        ? () => true
                        : brand =>
                            brand.name
                              .toUpperCase()
                              .includes(
                                this.state.brandFilter.trim().toUpperCase()
                              )
                    )
                    .map(brand => (
                      <ListItem
                        onClick={() => this.handleChange('brand', brand.id)}
                        key={brand.id}
                        className={
                          this.state.appliedFilters.brand.includes(brand.id)
                            ? classes.selectedItem
                            : ''
                        }
                        divider
                      >
                        {this.state.appliedFilters.brand.includes(brand.id) && (
                          <Check
                            color="primary"
                            style={{ marginRight: '6px' }}
                          />
                        )}
                        {brand.name}
                      </ListItem>
                    ))}
                </List>
              </div>
            </div>
            <Divider />
            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>
                {i18next.t('size')}:
              </Typography>
              <div className={classes.filterOptions}>
                {sizes.map(size => (
                  <Button
                    key={size.id}
                    onClick={() => this.handleChange('size', size.id)}
                    className={`${classes.filterOptionButton} ${
                      this.state.appliedFilters.size.includes(size.id)
                        ? classes.selectedOption
                        : ''
                    }`}
                    variant="outlined"
                  >
                    {size.name}
                  </Button>
                ))}
              </div>
            </div>
            <Divider />

            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>Tags:</Typography>
              <div className={classes.tagsOptions}>
                <div className={classes.tagOption}>
                  <TagAutocomplete
                    options={tags.filter(t => t.type === 'OCCASION')}
                    values={this.state.appliedFilters.tags}
                    setValue={values => this.handleChange('tags', values)}
                    label="ocasión"
                    type="OCCASION"
                    classes={classes}
                  />
                  <TagAutocomplete
                    options={tags.filter(t => t.type === 'STYLE')}
                    values={this.state.appliedFilters.tags}
                    setValue={values => this.handleChange('tags', values)}
                    label="estilo"
                    type="STYLE"
                    classes={classes}
                  />
                  <TagAutocomplete
                    options={tags.filter(t => t.type === 'MATERIAL')}
                    values={this.state.appliedFilters.tags}
                    setValue={values => this.handleChange('tags', values)}
                    label="material"
                    type="MATERIAL"
                    classes={classes}
                  />
                </div>
              </div>
            </div>
            <Divider />
            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>Color:</Typography>
              <div className={classes.filterOptions}>
                {colors.map(color => (
                  <ColorSelector
                    key={color.id}
                    size={25}
                    color={color}
                    iconClass={classes.colorSelector}
                    onClick={color => this.handleChange('color', color.id)}
                    selected={this.state.appliedFilters.color.includes(
                      color.id
                    )}
                  />
                ))}
              </div>
            </div>
            <Divider />

            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>Estado:</Typography>
              <div className={classes.filterOptions}>
                {this.state.facets.condition &&
                  Object.keys(this.state.facets.condition).map(condition => (
                    <Button
                      key={condition}
                      onClick={() => this.handleChange('condition', condition)}
                      className={`${classes.filterOptionButtonCondition} ${
                        this.state.appliedFilters.condition.includes(condition)
                          ? classes.selectedOption
                          : ''
                      }`}
                      variant="outlined"
                    >
                      {translateCondition(condition)}
                    </Button>
                  ))}
              </div>
            </div>
            <Divider />
            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>
                {i18next.t('dresserType', { ns: 'shop' })}
              </Typography>
              <div className={classes.filterOptions}>
                {this.state.facets.role &&
                  Object.keys(this.state.facets.role)
                    .filter(
                      r =>
                        r !== 'ROLE_USER' &&
                        r !== 'ROLE_ROOT' &&
                        r !== 'ROLE_SHOWROOM_PENDING' &&
                        r !== 'ROLE_SHOWROOM_PENDING_REVIEW'
                    )
                    .map(role => (
                      <Button
                        key={role}
                        onClick={() => this.handleChange('role', role)}
                        className={`${classes.filterOptionButton} ${
                          this.state.appliedFilters.role.includes(role)
                            ? classes.selectedOption
                            : ''
                        }`}
                        variant="outlined"
                      >
                        {translateRole(role)}
                      </Button>
                    ))}
                {this.state.facets.subTypes &&
                  Object.keys(this.state.facets.subTypes).map(subType => (
                    <Button
                      key={subType}
                      onClick={() => this.handleChange('subTypes', subType)}
                      className={`${classes.filterOptionButton} ${
                        this.state.appliedFilters.subTypes.includes(subType)
                          ? classes.selectedOption
                          : ''
                      }`}
                      variant="outlined"
                    >
                      {translateRole(subType)}
                    </Button>
                  ))}
                {!this.props.dresserView && (
                  <Button
                    onClick={() =>
                      this.handleChange(
                        'users',
                        this.state.appliedFilters.users === 'followings'
                      )
                    }
                    className={`${classes.filterOptionButton} ${
                      this.state.appliedFilters.users === 'followings'
                        ? classes.selectedOption
                        : ''
                    }`}
                    variant="outlined"
                  >
                    {i18next.t('dressersYouFollow', { ns: 'shop' })}
                  </Button>
                )}
              </div>
            </div>
            <Divider />
            <div className={classes.filter}>
              <div className={classes.filterOptions}>
                <TextField
                  label="Precio mínimo"
                  fullWidth
                  classes={{
                    root: classes.curvedSearch
                  }}
                  InputProps={{
                    classes: {
                      input: classes.input
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoney />
                      </InputAdornment>
                    )
                  }}
                  variant="outlined"
                  value={this.state.priceRange[0]}
                  onChange={({ target: { value } }) => {
                    if (
                      value !== '' &&
                      !value.match(/^\d+$/g) &&
                      value.length > 10
                    ) {
                      return;
                    }
                    this.handlePriceChange(true, value);
                  }}
                  onKeyDown={e => e.key === 'Enter' && e.target.blur()}
                  onBlur={() => {
                    if (
                      this.state.priceRange[0] === this.state.lastPriceRange[0]
                    ) {
                      return;
                    }
                    if (
                      Number(this.state.priceRange[0]) >
                      Number(this.state.priceRange[1])
                    ) {
                      this.setState(
                        state => ({
                          ...state,
                          priceRange: [
                            Number(this.state.priceRange[1] - 1),
                            this.state.priceRange[1]
                          ]
                        }),
                        () =>
                          this.handleChange(
                            'minPrice',
                            Number(this.state.priceRange[1] - 1)
                          )
                      );
                      return;
                    }
                    this.handleChange('minPrice', this.state.priceRange[0]);
                  }}
                />
                <TextField
                  label="Precio máximo"
                  fullWidth
                  classes={{
                    root: classes.curvedSearch
                  }}
                  InputProps={{
                    classes: {
                      input: classes.input
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoney />
                      </InputAdornment>
                    )
                  }}
                  variant="outlined"
                  value={this.state.priceRange[1]}
                  onChange={({ target: { value } }) => {
                    if (
                      value !== '' &&
                      !value.match(/^\d+$/g) &&
                      value.length > 10
                    ) {
                      return;
                    }
                    this.handlePriceChange(false, value);
                  }}
                  onKeyDown={e => e.key === 'Enter' && e.target.blur()}
                  onBlur={() => {
                    if (
                      this.state.priceRange[1] === this.state.lastPriceRange[1]
                    ) {
                      return;
                    }
                    if (
                      Number(this.state.priceRange[1]) <
                      Number(this.state.priceRange[0])
                    ) {
                      this.setState(
                        state => ({
                          ...state,
                          priceRange: [
                            this.state.priceRange[0],
                            Number(this.state.priceRange[0] + 1)
                          ]
                        }),
                        () =>
                          this.handleChange(
                            'maxPrice',
                            Number(this.state.priceRange[0] + 1)
                          )
                      );
                      return;
                    }
                    this.handleChange('maxPrice', this.state.priceRange[1]);
                  }}
                />
              </div>
            </div>
            <Divider />
            {this.state.facets.promo !== undefined &&
              Object.keys(this.state.facets.promo).length > 0 && (
                <>
                  <div className={classes.filter}>
                    <Typography className={classes.filterHeader}>
                      Con promo:
                    </Typography>
                    <div className={classes.filterOptions}>
                      {this.state.facets.promo !== undefined &&
                        Object.keys(this.state.facets.promo).map(promo => (
                          <Button
                            key={promo}
                            onClick={() => this.handleChange('promo', promo)}
                            className={`${classes.filterOptionButton} ${
                              this.state.appliedFilters.promo.includes(promo)
                                ? classes.selectedOption
                                : ''
                            }`}
                            variant="outlined"
                          >
                            {translatePromotion(promo)}
                          </Button>
                        ))}
                    </div>
                  </div>
                  <Divider />
                </>
              )}
            <div className={classes.filter}>
              <Typography className={classes.filterHeader}>
                Forma de envio:
              </Typography>
              <div className={classes.filterOptions}>
                {this.state.facets.shipping &&
                  Object.keys(this.state.facets.shipping)
                    .filter(shipping => shipping !== 'WELIVERY')
                    .map(shipping => (
                      <Button
                        key={shipping}
                        onClick={() => this.handleChange('shipping', shipping)}
                        className={`${classes.filterOptionButton} ${
                          this.state.appliedFilters.shipping.includes(shipping)
                            ? classes.selectedOption
                            : ''
                        }`}
                        variant="outlined"
                      >
                        {translateShipping(shipping)}
                      </Button>
                    ))}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  productFacets: state.product.productsFacets,
  dressersFacets: state.user.dressersFacets,

  productStatus: state.product.status,
  dressersStatus: state.user.status,

  categories: state.categories.categories,
  brands: state.categories.brands,
  sizes: state.categories.allSizes,
  tags: state.categories.tags,
  colors: state.categories.colors
});

const mapDispatchToProps = dispatch => ({
  fetchSizes: () => dispatch(fetchAllSizes()),
  fetchCategories: () => dispatch(fetchCategories()),
  fetchBrands: () => dispatch(fetchBrands()),
  fetchColors: () => dispatch(fetchColors()),
  fetchTags: () => dispatch(fetchTags())
});

export default withStyles(styles)(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withWidth()(ProductFilter))
  )
);
